import request from '../../src/state/modules/axios'

export function getSchoolJobVacancy(params){
    return request({
        url: '/api/school-job-vacancies',
        method: 'get',
        params,
    })
}

export function showSchoolJob(id){
    return request({
        url:`/api/school-job-vacancies/${id}`,
        method: 'get'
    })
}

export function showAllJobs(id){
    return request({
        url:`/api/school-job-vacancies/${id}`,
        method: 'get'
    })
}

export function applicationAllJobs(id){
    return request({
        url:`/api/school-job-vacancies/${id}`,
        method: 'get'
    })
}

export function applicationAllFJobs(id){
    return request({
        url:`/api/school-job-fvacancies/${id}`,
        method: 'get'
    })
}

export function addSchoolJobVacancy(data){
    return request({
        url: '/api/school-job-vacancies',
        method: 'post',
        data,
    })
}

export function editSchoolJobVacancy(data){
    return request({
        url: `/api/school-job-vacancies/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteSchoolJobVacancy(data){
    return request({
        url: `/api/school-job-vacancies/${data.id}`,
        method: 'delete'
    })
}

export function updateSchoolVacancyStatus(data) {
    return request({
        url: '/api/school-vacancies-update/update-status',
        method: "put",
        data,
    })
}

export function updateSchoolFVacancyStatus(data) {
    return request({
        url: '/api/school-fvacancies-update/update-status',
        method: "put",
        data,
    })
}

export function getSchoolVacancies(params) {
    return request({
        url:'/api/school-vacancies',
        method: "get",
        params,
    })
}

export function showSchoolVacancy(id){
    return request({
        url:`/api/school-vacancies/${id}`,
        method: 'get'
    })
}


export function getSchoolFVacancies(params) {
    return request({
        url:'/api/school-fvacancies',
        method: "get",
        params,
    })
}

export function editSchoolJobFVacancy(data){
    return request({
        url: `/api/school-job-fvacancies/${data.id}`,
        method: 'put',
        data,
    })
}

export function addSchoolJobFVacancy(data){
    return request({
        url: '/api/school-job-fvacancies',
        method: 'post',
        data,
    })
}
export function getSchoolJobFVacancy(params){
    return request({
        url: '/api/school-job-fvacancies',
        method: 'get',
        params,
    })
}

export function showAllFJobs(id){
    return request({
        url:`/api/school-job-fvacancies/${id}`,
        method: 'get'
    })
}
